import { render, staticRenderFns } from "./ad-planner-read-only.vue?vue&type=template&id=1c4f31ad"
import script from "./ad-planner-read-only.vue?vue&type=script&lang=js"
export * from "./ad-planner-read-only.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1671620415/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c4f31ad')) {
      api.createRecord('1c4f31ad', component.options)
    } else {
      api.reload('1c4f31ad', component.options)
    }
    module.hot.accept("./ad-planner-read-only.vue?vue&type=template&id=1c4f31ad", function () {
      api.rerender('1c4f31ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ads/ad-planner-read-only.vue"
export default component.exports